import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class Step138672Meta extends BaseModel {
  hasAcknowledgedNotLegalBinding?: boolean;

  constructor(model: Partial<Step138672Meta> = {}) {
    super();

    this.hasAcknowledgedNotLegalBinding = model.hasAcknowledgedNotLegalBinding ?? false;
  }
}

